module.exports = __webpack_public_path__ + "img/中国桥牌协会@2x.bb8f976c.png";